import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isLoading: false,
  operationType: undefined,
  userSetting: undefined,
  guestSetting: undefined,
  customFields: [],
  customFieldsIdToObjMap: new Map(),
  defaultFields: [],
  defaultFieldsIdToObjMap: new Map(),
  defaultFieldsNameToObjMap: new Map(),
  userTypesList: [],
  userTypeIdToObjMap: new Map(),
  selectedUserTypeObj: undefined,
  notificationSettings: undefined,
  emailTemplateDetails: {},
  customEmailTemplate: {},
  teamRoles: [],
  blockedContacts: [],
  blockedAccountMatch: null,
  blockedAccountMatchLoading: false
}

export const settingSlice = createSlice({
  name: 'setting',
  initialState: { ...initialState },
  reducers: {
    sagaSuccess: (state, action) => {
      if (action.payload) {
        Object.assign(state, action.payload);
      }
    },
    sagaFailed: (state, action) => {
      if (action.payload) {
        Object.assign(state, action.payload);
      }
      else state.operationType = undefined;
      state.isLoading = false;
    },
    resetOperationType: (state, action) => {
      state.operationType = ""
    },
    addClassroom: (state, action) => {
      state.isLoading = true
    },
    deleteClassroom: (state, action) => {
      state.isLoading = true
    },
    addSettings: (state, action) => {
      state.isLoading = true
    },
    deleteSettings: (state, action) => {
      state.isLoading = true
    },
    confirmSettings: (state, action) => {
      state.isLoading = true
    },
    getUserSettings: (state, action) => {
      state.isLoading = true
    },
    getGuestSettings: (state, action) => {
      state.isLoading = true
    },
    createStudentCustomField: (state, action) => {
      state.isLoading = true
    },
    getCustomFields: (state, action) => {
      state.isLoading = true
    },
    deleteCustomField: (state, action) => {
      state.isLoading = true
    },
    saveOrderChangesInDB: (state, action) => {
      state.isLoading = true
    },
    getUserTypesList: (state, action) => {
      state.isLoading = true
    },
    createNewUserType: (state, action) => {
      state.isLoading = true
    },
    updateSelectedUserType: (state, action) => {
      state.isLoading = true
    },
    updateSchoolConfigInMasterDB: (state, action) => {
      state.isLoading = true
    },
    saveGeneralSettings: (state, action) => {
      state.isLoading = true
    },
    sendStripeCodeToBackend: (state, action) => {
      state.isLoading = true
    },
    saveAttendanceSettings: (state, action) => {
      state.isLoading = true
    },
    syncIllumineStudents: (state, action) => {
      state.isLoading = true
    },
    getNotificationSettings: (state, action) => {
      state.isLoading = true
    },
    setNotificationSettings: (state, action) => {
      state.isLoading = true
    },
    getEmailTemplateDetails: (state, action) => {

    },
    setEmailTemplateDetails: (state, action) => {
      state.isLoading = true;
    },
    getCustomEmailTemplate: (state, action) => {
      state.isLoading = true;
    },
    saveCustomEmailTemplate: (state, action) => {
      state.isLoading = true;
    },
    getTeamRoles: (state, action) => {
      state.isLoading = true;
    },
    getBlockedContacts: (state, action) => {
      state.isLoading = true;
    },
    getBlockedAccountMatch: (state, action) => {
      state.blockedAccountMatchLoading = true;
    },
  }
})

export const {
  sagaSuccess,
  resetOperationType,
  addClassroom,
  deleteClassroom,
  addSettings,
  deleteSettings,
  confirmSettings,
  getUserSettings,
  getGuestSettings,
  createStudentCustomField,
  getCustomFields,
  deleteCustomField,
  saveOrderChangesInDB,
  getUserTypesList,
  createNewUserType,
  updateSelectedUserType,
  updateSchoolConfigInMasterDB,
  saveGeneralSettings,
  sendStripeCodeToBackend,
  saveAttendanceSettings,
  syncIllumineStudents,
  getNotificationSettings,
  setNotificationSettings,
  getEmailTemplateDetails,
  setEmailTemplateDetails,
  getCustomEmailTemplate,
  saveCustomEmailTemplate,
  getTeamRoles,
  getBlockedContacts,
  getBlockedAccountMatch,
} = settingSlice.actions;

export default settingSlice.reducer